// Skeleton component for loading state
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './GenericTable.scss';

const TableSkeleton = ({ columns, rowsCount = 5 }) => {
  return (
    <div className="table-skeleton">
      <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
        <table className='table table-hover'>
          <thead>
            <tr>
              {columns.map(
                (column, index) =>
                  column.key != 'collapsed' && (
                    <th
                      key={index}
                      className={`${column.sortable ? 'sortable' : ''} ${column.align ? `text-${column.align}` : ''}`}
                      style={{width: column.width}}>
                      <div className='th-content'>
                        <div className='column-title'>{column.title}</div>
                        {column.sortable && (
                          <div className='sort-icon-container'>
                            <Skeleton width={16} height={16} />
                          </div>
                        )}
                      </div>
                    </th>
                  ),
              )}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rowsCount }).map((_, rowIndex) => (
              <tr key={rowIndex} className='fu-table-row skeleton-row'>
                {columns.map((column, colIndex) =>
                  column.key != 'collapsed' ? (
                    <td key={colIndex} className={column.align ? `text-${column.align}` : ''} style={{width: column.width}}>
                      <Skeleton height={20} />
                    </td>
                  ) : null,
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </SkeletonTheme>
    </div>
  );
};

export default TableSkeleton;
  